import { useTheme } from '@mui/material';

export default function ArchivedBusinessesIcon() {
  const theme = useTheme();
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_54822_136432'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='18'
        height='18'
      >
        <rect width='17.23' height='17.23' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_54822_136432)'>
        <path
          d='M4.65586 15.6754C4.31916 15.6754 4.03092 15.5555 3.79114 15.3157C3.55137 15.076 3.43148 14.7877 3.43148 14.451V7.44487C3.19341 7.35417 2.99785 7.20396 2.8448 6.99423C2.69176 6.7845 2.61523 6.54926 2.61523 6.28851V3.83976C2.61523 3.50306 2.73512 3.21482 2.97489 2.97505C3.21467 2.73527 3.50291 2.61539 3.83961 2.61539H14.4509C14.7876 2.61539 15.0758 2.73527 15.3156 2.97505C15.5553 3.21482 15.6752 3.50306 15.6752 3.83976V6.28851C15.6752 6.54926 15.5987 6.7845 15.4457 6.99423C15.2926 7.20396 15.0971 7.35417 14.859 7.44487V14.4486C14.859 14.7903 14.7391 15.0802 14.4993 15.3183C14.2596 15.5564 13.9713 15.6754 13.6346 15.6754H4.65586ZM4.65586 7.51289V14.451H13.6346V7.51289H4.65586ZM3.83961 6.28851H14.4509V3.83976H3.83961V6.28851ZM7.51273 10.3698H10.7777V9.14539H7.51273V10.3698Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
